import { render, staticRenderFns } from "./AttorePersonalData.vue?vue&type=template&id=3eba6d82&"
import script from "./AttorePersonalData.vue?vue&type=script&lang=ts&"
export * from "./AttorePersonalData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports